import { render, staticRenderFns } from "./formattedMedkitlogDate.vue?vue&type=template&id=031e81c3"
import script from "./formattedMedkitlogDate.vue?vue&type=script&lang=js"
export * from "./formattedMedkitlogDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports